<spk-card [class]="'col-md-3'" meta="{{ getActionText() }} Example" title="{{model.DisplayText}}" [divider]="true">
  <formly-form [fields]="fields" [model]="model" [options]="options" [form]="form"> </formly-form>
</spk-card>